import { createFileRoute, useParams } from "@tanstack/react-router";
import { AssetTypeActivitySection } from "@/utils/asset-type-detail/asset-type-activity-section";
import { useAssetTypeDrawerContext } from "@/utils/asset-type-detail/asset-type-drawer-context";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/activity",
)({
	component: OrgAssetTypeActivityTab,
});

function OrgAssetTypeActivityTab() {
	const { orgId } = useParams({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/activity",
	});
	const { assetType } = useAssetTypeDrawerContext();

	return (
		<div className="p-4">
			<AssetTypeActivitySection
				assetType={assetType}
				variant="drawer"
				organizationId={orgId}
			/>
		</div>
	);
}
